/**
 * IMPORTANT:
 *  - dont use it anywhere else - it should be close to where it's really needed,
 *      if you need to share functionality, create a service and inject it here;
 *
 * NOTE:
 *  This Controller is needed, because the stupid `temp_post_node` PHP function can be placed in any AngularJS scope
 *  which makes it hard to reason about the availability of some AngularJS scope functions.
 *
 * We are just using a dedicated controller close to the place where it's needed.
 *  - you wont forget to add it in higher scope
 *  - it's clear why it's needed
 */
(function () {
    angular.module('tradersyard').controller('WallPostTrackerCtrl', WallPostTrackerCtrl);

    WallPostTrackerCtrl.$inject = ['PostsService', 'AuthService'];

    function WallPostTrackerCtrl(PostsService, AuthService) {
        const ctrl = this;

        ctrl.shouldShowBoostButton = shouldShowBoostButton;

        /**
         * Items in ng-repeat need to be tracked by an unique ID.
         * This controller takes care of generating it for a post.
         * @param postNode
         * @return {string}
         */
        ctrl.postId = (postNode) => {
            // Wall can contain duplicate posts if they are promoted. If the post is marked as `isPromoted`,
            // assume we have a `boost` prop. The `boost.id` should be unique - at least currently.
            if (postNode.isPromoted) {
                return `${postNode.id}-${postNode.boost.id}`;
            }

            return '' + postNode.id;
        };

        /**
         * Boost Button in post area should only be shown to the people most likely interested in boosting a post.
         * We believe those are the people who host Webinars and Offices.
         * Most recently we also included private posts from users on this list.
         *
         * @param {PostNode} postNode
         */
        function shouldShowBoostButton(postNode) {
            const isPublic = postNode.privacy === 'public';
            const showButtonForEntry = ['webinar', 'group', 'user'].includes(postNode.entry);
            const canAdminister = PostsService.canBoostPost(postNode);

            return isPublic && showButtonForEntry && canAdminister && _shouldUserSeeSocialApp();
        }

        // TODO: Remove this check when we go "live" with SA
        function _shouldUserSeeSocialApp() {
            // Flo Rian, Andre Schulters
            const allowedUsers = [2280, 2566];

            const userId = AuthService.getUserId();
            const isSuperAdmin = AuthService.isAdmin();
            const isAllowedUser = allowedUsers.includes(userId);

            return isSuperAdmin || isAllowedUser;
        }
    }
})();
